<template>
  <v-layout justify-center>
    <!-- loaging -->
    <v-overlay :value="overlay">
      <img
        :src="require('@/Arquivos/onload.gif')"
        style="width: 70px; height: 70px"
      />
    </v-overlay>
    <!-- loaging -->

    <!-- MENSAGEM -->
    <v-snackbar
      style="position: absolute; top: -25%; left: 0"
      elevation="13"
      v-model="alert"
    >
      {{ msgAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="fecharAlert()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- MENSAGEM -->

    <!-- DIALOG BAIXA APP -->
    <v-dialog v-model="dialogNoticia" max-width="290px">
      <v-img
        :src="require('@/Arquivos/baixeOAplicativo.png')"
        style="width: 310px; height: 550px; position: center"
      >
        <br /><br /><br /><br /><br /><br /><br /><br />
        <v-row align="center" justify="center">
          <v-btn
            color="#feca26"
            class="ma-0"
            style="
              width: 270px;
              height: 60px;
              background-position: center center;
            "
            @click="
              redirecionarPagina(
                'https://play.google.com/store/apps/details?id=com.gmail.limanieroficial.joaocesarmattogrosso'
              )
            "
            ><v-icon large>mdi-google-play</v-icon>
            <v-spacer>
              <strong style="color: black">Baixar para Android</strong>
            </v-spacer>
          </v-btn>
          <br /><br /><br />
         <v-btn
            color="#feca26"
            class="ma-0"
            style="
              width: 270px;
              height: 60px;
              background-position: center center;
            "
            @click="
              redirecionarPagina(
                'https://apps.apple.com/us/app/chama-o-jo%C3%A3o/id1563087514'
              )
            "
            ><v-icon large>mdi-apple</v-icon>
            <v-spacer>
              <strong style="color: black">Baixar para IOS</strong>
            </v-spacer>
          </v-btn>
          <br /><br /><br />

          <v-btn
            text
            color="blue"
            class="ma-0"
            style="
              width: 270px;
              height: 60px;
              background-position: center center;
            "
            @click="dialogNoticia = false"
            ><v-icon large>mdi-web</v-icon
            ><v-spacer
              ><strong style="color: blue">
                Continuar pelo site
              </strong></v-spacer
            ></v-btn
          >
        </v-row>
      </v-img>
    </v-dialog>
    <!-- DIALOG BAIXA APP -->

    <!-- SITE -->
    <v-img
      v-if="$vuetify.breakpoint.width > 900"
      :src="require('@/Arquivos/TelaFundoLogin.gif')"
    >
      <br /><br /><br /><br /><br />
      <v-row align="center" justify="center">
        <v-card-text style="width: 300px">
          <v-form>
            <v-text-field
              prepend-icon="mdi-email-outline"
              name="login"
              label="E-mail"
              type="text"
              v-model="email"
              dark
            ></v-text-field>
            <v-text-field
              id="password"
              prepend-icon="mdi-key"
              name="password"
              label="Senha"
              type="password"
              v-model="senha"
              dark
            ></v-text-field>
          </v-form>
        </v-card-text>
      </v-row>
      <v-row align="center" justify="center">
        <v-btn
          color="#feca26"
          class="ma-0"
          style="
            width: 200px;
            height: 40px;
            color: white;
            background-position: center center;
          "
          @click="FazerLogin()"
        >
          <strong style="color: black"> Entrar</strong></v-btn
        >
      </v-row>

      <br />
      <v-row align="center" justify="center">
        <v-btn
          class="ma-2"
          small
          outlined
          color="white"
          @click="dialogCadastro = true"
          >Criar uma Conta</v-btn
        >
      </v-row>
      <v-row align="center" justify="center">
        <v-btn
          small
          class="ma-2"
          outlined
          color="yellow"
          @click="
            email
              ? ResetarSenha()
              : mensagemAlerta('Primeiro, preencha o campo E-mail')
          "
        >
          Esqueci a Senha</v-btn
        >
      </v-row>

      <!-- dialog novo Cadastro -->
      <v-dialog v-model="dialogCadastro" width="500">
        <v-card>
          <v-toolbar dark color="#5184e0">
            <v-toolbar-title>Nova Conta</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="mdi-email-outline"
                name="login"
                label="Novo E-mail"
                type="text"
                v-model="email"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="mdi-key"
                name="password"
                label="Nova Senha"
                type="password"
                v-model="senha"
              ></v-text-field>
              <v-icon color="orange">mdi-alert-circle</v-icon> mínimo 6
              caracteres
            </v-form>
          </v-card-text>

          <v-row align="center" justify="center">
            <v-btn
              color="#feca26"
              style="
                width: 200px;
                height: 40px;

                color: white;
                background-position: center center;
              "
              @click="CriarPerfil()"
              ><strong style="color: black"> Cadastrar</strong></v-btn
            >
            <div style="margin-left: -20px !important"></div>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogCadastro = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog novo Cadastro -->
    </v-img>
    <!-- SITE -->

    <!-- APP -->
    <v-img
      v-if="$vuetify.breakpoint.width < 900"
      :src="require('@/Arquivos/capaLoginMobile.gif')"
      style="width: 100%; height: 100%; position: absolute; top: 0%; left: 0"
    >
      <br /><br /><br /><br /><br />

      <v-row align="center" justify="center">
        <v-card-text style="width: 300px">
          <v-form>
            <v-text-field
              prepend-icon="mdi-email-outline"
              name="login"
              label="E-mail"
              type="text"
              v-model="email"
            ></v-text-field>
            <v-text-field
              id="password"
              prepend-icon="mdi-key"
              name="password"
              label="Senha"
              type="password"
              v-model="senha"
            ></v-text-field>
          </v-form>
        </v-card-text>
      </v-row>
      <v-row align="center" justify="center">
        <v-btn
          color="#feca26"
          class="ma-0"
          style="
            width: 200px;
            height: 40px;
            color: white;
            background-position: center center;
          "
          @click="FazerLogin()"
          ><strong style="color: black"> Entrar</strong></v-btn
        >
      </v-row>
      <v-row align="center" justify="center">
        <v-btn
          color="#0080ed"
          class="ma-2"
          style="width: 200px; height: 40px; background-position: center center"
          @click="signInWithFacebook()"
          ><v-icon>mdi-facebook</v-icon
          ><strong style="color: black">Facebook</strong></v-btn
        >
      </v-row>

      <v-row align="center" justify="center">
        <v-btn
          class="ma-2"
          small
          outlined
          color="white"
          @click="dialogCadastro = true"
          >Criar uma Conta</v-btn
        >
      </v-row>
      <v-row align="center" justify="center">
        <v-btn
          small
          class="ma-2"
          outlined
          color="yellow"
          @click="
            email
              ? ResetarSenha()
              : mensagemAlerta('Primeiro, preencha o campo E-mail')
          "
        >
          Esqueci a Senha</v-btn
        >
      </v-row>

      <!-- dialog novo Cadastro -->
      <v-dialog v-model="dialogCadastro" width="500">
        <v-card>
          <v-toolbar dark color="#5184e0">
            <v-toolbar-title>Nova Conta</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="mdi-email-outline"
                name="login"
                label="Novo E-mail"
                type="text"
                v-model="email"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="mdi-key"
                name="password"
                label="Nova Senha"
                type="password"
                v-model="senha"
              ></v-text-field>
              <v-icon color="orange">mdi-alert-circle</v-icon> mínimo 6
              caracteres
            </v-form>
          </v-card-text>

          <v-row align="center" justify="center">
            <v-btn
              color="#feca26"
              style="
                width: 200px;
                height: 40px;

                color: white;
                background-position: center center;
              "
              @click="CriarPerfil()"
              ><strong style="color: black"> Cadastrar</strong></v-btn
            >
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogCadastro = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog novo Cadastro -->
    </v-img>
    <!-- APP -->
  </v-layout>
</template>

<script>
import "firebaseui/dist/firebaseui.css";
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Login",
  data() {
    return {
      dialogNoticia: false,
      overlay: false,
      email: "",
      senha: "",
      alert: false,
      msgAlert: "",
      dialogCadastro: false,
    };
  },
  components: {},

  mounted() {
    this.loading();
    this.drawer = true;
  },

  methods: {
    redirecionarPagina(link) {
      window.location.href = "" + link;
    },
    FazerLogin() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.senha)
        .then(() => {
          this.mensagemAlerta("Olá! Seja bem-vindo(a)");
        })
        .catch((error) => {
          if (error.code == "auth/user-not-found") {
            this.mensagemAlerta("Email não cadastrado");
          }
          if (
            error.code == "auth/wrong-password" ||
            error.code == "auth/too-many-requests"
          ) {
            this.mensagemAlerta("Informe uma senha válida");
          }
          if (error.code == "auth/invalid-email") {
            this.mensagemAlerta("Informe um e-mail válido");
          }
        });
    },

    CriarPerfil() {
      if (!this.email || !this.senha) {
        this.mensagemAlerta("Informe e-mail e senha para o cadastro");
        return;
      }

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.senha)
        .then(() => {
          this.mensagemAlerta("Conta criada com sucesso. Cadastre seu Perfil.");
        })
        .catch((error) => {
          console.log(error.code);
          if (error.code == "auth/invalid-email") {
            this.mensagemAlerta("Informe um e-mail válido");
          }
          if (error.code == "auth/weak-password") {
            this.mensagemAlerta(
              "Senha Fraca. São permitidos 6 caracteres no mínimo"
            );
          }
          if (error.code == "auth/email-already-in-use") {
            this.mensagemAlerta("E-mail já cadastrado.");
          }
        });
    },

    ResetarSenha() {
      var emailUsuario = this.email;

      //SE NAO DEU CERTO ENTAO ENVIA EMAIL
      firebase
        .auth()
        .sendPasswordResetEmail(emailUsuario)
        .then(() => {
          this.mensagemAlerta(
            "Enviamos um E-mail para a alteração da Senha. Verifique a Cxa de Entrada e Spam do E-mail: " +
              emailUsuario
          );
        })
        .catch((error) => {
          console.log(error);
          if (error.code == "auth/user-not-found") {
            this.mensagemAlerta(
              "E-mail não cadastrado. Clique em 'CRIAR UMA CONTA'"
            );
          } else {
            this.mensagemAlerta(
              "Ocorreu algum Problema na redefinição de senha. Por favor tente mais tarde."
            );
          }
        });
    },

    signInWithFacebook() {
      var provider = new firebase.auth.FacebookAuthProvider();

      firebase
        .auth()
        .signInWithRedirect(provider)
        .then(() => {
          // var token = result.credential.accessToken;
          // var user = result.user;
          //this.$router.replace("/");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async mensagemAlerta(msg) {
      this.fecharAlert();
      this.msgAlert = "\n" + msg + "\n";
      this.alert = true;
    },

    fecharAlert() {
      this.alert = false;
      this.msgAlert = "";
    },

    async loading() {
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
        this.dialogNoticia = true;
      }, 1500);
    },
  },
};
</script>

<style>
</style>